import ICON_BAKERY from './assets/bakery.png';
import ICON_CHICKEN from './assets/chicken.png';
import ICON_CHINESE from './assets/chinese.png';
import ICON_COFFEE from './assets/coffee.png';
import ICON_CONVENIENCE from './assets/convenience.png';
import ICON_DESSERT from './assets/dessert.png';
import ICON_EDUCATION from './assets/education.png';
import ICON_FASTFOOD from './assets/fastfood.png';
import ICON_FUSION from './assets/fusion.png';
import ICON_INTERNETCAFE from './assets/internetcafe.png';
import ICON_JAPANESE from './assets/japanese.png';
import ICON_KOREAN from './assets/korean.png';
import ICON_LAUNDRY from './assets/laundry.png';
import ICON_LEISURE from './assets/leisure.png';
import ICON_LIFE from './assets/life.png';
import ICON_PIZZA from './assets/pizza.png';
import ICON_PUB from './assets/pub.png';
import ICON_SNACK from './assets/snack.png';
import ICON_STUDY from './assets/study.png';
import ICON_WESTERN from './assets/western.png';
import ICON_WHOLESALE_RETAIL from './assets/wholesaleretail.png';

export const CATEGORY_ICON_MAP = {
  카페: ICON_COFFEE,
  제과제빵: ICON_BAKERY,
  디저트: ICON_DESSERT,
  한식: ICON_KOREAN,
  중식: ICON_CHINESE,
  일식: ICON_JAPANESE,
  양식: ICON_WESTERN,
  '별식·퓨전요리': ICON_FUSION,
  주점: ICON_PUB,
  치킨: ICON_CHICKEN,
  피자: ICON_PIZZA,
  분식: ICON_SNACK,
  패스트푸드: ICON_FASTFOOD,
  편의점: ICON_CONVENIENCE,
  도소매: ICON_WHOLESALE_RETAIL,
  pc방: ICON_INTERNETCAFE,
  '여가·오락': ICON_LEISURE,
  '교육·유아': ICON_EDUCATION,
  '스터디카페·독서실': ICON_STUDY,
  빨래방: ICON_LAUNDRY,
  생활서비스: ICON_LIFE,
};
